module.exports = __webpack_public_path__ + "static/media/phb.7b160192.webp";